module.exports = __webpack_public_path__ + "static/img/zero.2a25639.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cards/misc/zero.png
// module id = 0cIE
// module chunks = 1